<template>
  <div class="chre-box">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="width:100%;height:700px;">
      <el-tab-pane label="全部" name="first">哈哈哈</el-tab-pane>
      <el-tab-pane label="账号注册" name="second" class="zhuce">
          <span>- 如何找回登录密码？</span>
          <span>- 如何在苏宁易购网站注册账号</span>
          <span>- 如何修改登录密码？</span>
          <span>- 如何在苏宁易购APP注册账号</span>
          <span>- 帐号登录</span>
          <span>- 如何注册京东账号？</span>
          <span>- 如何注册企业会员？</span>
          <span>- 京东购物流程</span>
          <span>- 如何购买下单？</span>
          <span>- 如何查找想要的商品？</span>
          <span>- 可以拨打客服热线订购商品吗？</span>
          <span>- 如何填写收货地址？</span>
          <span>- 如何查看购物车中的商品？</span>
          <span>- 为什么收货地址里面没有我的地区所在的街道？</span>
          <span>- 购物车常见问题和购物技巧</span>
          <span>- 谨防假借京东名义的诈骗</span>
          <span>- 预售商品可以同时购买多件吗？</span>
          <span>- 优惠预估价是什么？</span>
      </el-tab-pane>
      <el-tab-pane label="下单流程" name="third">下单流程</el-tab-pane>
      <el-tab-pane label="挑选商品" name="fourth">挑选商品</el-tab-pane>
      <el-tab-pane label="提交订单" name="fifth">提交订单</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
    data() {
      return {
        activeName: 'second'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
}
</script>

<style lang="less" scoped>
.chre-box {
  margin-top: 40px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  .zhuce{
      span{
          display: block;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
      }
  }
}
</style>